import { Component, OnInit, OnDestroy } from "@angular/core";
import { DataService_barcode } from "../shared/data.service";

import { wsBarcodeManagementBarcodeStatusDataParmInfo } from "../shared/wsBarcodeManagementBarcodeStatusDataParmInfo";
import { wsBarcodeManagementBarcodeStatusDataInfo } from "../shared/wsBarcodeManagementBarcodeStatusDataInfo";
import { wsBarcodeManagementBarcodeStatusInfo } from "../shared/wsBarcodeManagementBarcodeStatusDataInfo";
import { wsBarcodeManagementCardStatusUpdateParm } from "../shared/wsBarcodeManagementCardStatusUpdateParm";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./status.component.html",
	styleUrls: ["./status.component.css"],
	providers: [ConfirmationService],
})
export class StatusComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_barcode,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserPersonID: number;
	public IDCardID: number;
	public IDStatusID: number;
	public Barcode: string;
	public UID: string;

	public BarcodeManagementBarcodeStatusData: wsBarcodeManagementBarcodeStatusDataInfo;
	public lstBarcodeStatusItems: wsBarcodeManagementBarcodeStatusInfo[] = [];
	public SelectedBarcodeStatus: wsBarcodeManagementBarcodeStatusInfo;

	public PersonID: number = -1;
	public FullName: string = "";
	public StaffStudentID: string = "";

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserPersonID = this.dialogConfig.data.UserPersonID;
		this.IDCardID = this.dialogConfig.data.IDCardID;
		this.IDStatusID = this.dialogConfig.data.IDStatusID;
		this.Barcode = this.dialogConfig.data.Barcode;
		this.UID = this.dialogConfig.data.UID;

		let parms: wsBarcodeManagementBarcodeStatusDataParmInfo = {
			AdministratorPersonID: this.UserPersonID,
			IDCardID: this.IDCardID,
		};

		this.isBusy = true;
		this.dataService.BarcodeManagementStatusDataGet(parms).subscribe((data) => this.BarcodeManagementStatusDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	BarcodeManagementStatusDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	BarcodeManagementStatusDataGet_Complete(data: any) {
		this.BarcodeManagementBarcodeStatusData = data;

		this.PersonID = this.BarcodeManagementBarcodeStatusData.PersonID;
		this.FullName = this.BarcodeManagementBarcodeStatusData.FullName;
		this.StaffStudentID = this.BarcodeManagementBarcodeStatusData.StaffStudentID;

		this.lstBarcodeStatusItems = this.BarcodeManagementBarcodeStatusData.BarcodeStatusItems;

		//
		//	Default select
		//
		this.SelectedBarcodeStatus = this.lstBarcodeStatusItems[0];
		this.lstBarcodeStatusItems.forEach((item) => {
			if (item.IDStatusID == this.IDStatusID) {
				this.SelectedBarcodeStatus = item;
			}
		});

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStatusChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStatusChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate() {
		this.ErrorMessage = "";

		let parms: wsBarcodeManagementCardStatusUpdateParm = {
			IDCardID: this.IDCardID,
			IDStatusID: this.SelectedBarcodeStatus.IDStatusID,
			MTACardStatusID: -1,
			c_PersonID: this.UserPersonID,
			Comment: "",
		};

		this.isBusy = true;
		this.dataService.BarcodeManagementCardStatusUpdate(parms).subscribe((data) => this.BarcodeManagementCardStatusUpdate_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	BarcodeManagementCardStatusUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	BarcodeManagementCardStatusUpdate_Complete(data: any) {
		this.isBusy = false;

		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(1);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
